import React from "react";
import propTypes from "prop-types";

import Modal from "react-bootstrap/cjs/Modal";
import Button from "react-bootstrap/cjs/Button";

const LogoutModal = ({ show, onHide, handleLogout }) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header>
      <Modal.Title>Logout</Modal.Title>
    </Modal.Header>
    <Modal.Body>Are you sure you want to log out?</Modal.Body>
    <Modal.Footer>
      <Button variant={"secondary"} onClick={onHide}>
        Close
      </Button>
      <Button variant={"warning"} onClick={handleLogout}>
        Logout
      </Button>
    </Modal.Footer>
  </Modal>
);

LogoutModal.propTypes = {
  show: propTypes.bool.isRequired,
  onHide: propTypes.func,
  handleLogout: propTypes.func,
};

LogoutModal.defaultProps = {
  show: false,
};

export default LogoutModal;
